import { styled } from '@mui/material'

// Soft fade behind bottom UI. Use rgba(0,0,0,0) — not the `transparent`
// keyword — because iOS Safari interpolates `transparent` as a muddy gray fill.
// Matches iOS ScannerControlsView: clear → 60% black @ 55% → 90% black @ bottom.
const BottomScrim = styled('div')({
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height: '260px',
    pointerEvents: 'none',
    zIndex: 4,
    backgroundImage:
        'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 55%, rgba(0,0,0,0.9) 100%)',
})

export { BottomScrim }
